export const Circle = (props: any) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		data-aid="svgCircle"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		{...props}
	>
		<circle cx="12" cy="12" r="10" />
	</svg>
);
